import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Lock, Mail, Loader2, AlertCircle } from 'lucide-react'
import useAuthStore from '../store/authStore'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const { login, isLoading, error } = useAuthStore()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const success = await login(email, password)
    if (success) {
      navigate('/admin/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-cidh-blue flex items-center justify-center p-4">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="bg-white w-full max-w-md p-8 rounded-2xl shadow-2xl"
      >
        <div className="text-center mb-8">
          <img 
            src="/logo.png" 
            alt="CIDH Consulting Logo" 
            className="h-28 w-auto mx-auto mb-4 object-contain"
          />
          <h1 className="text-2xl font-bold text-cidh-blue font-montserrat">Administration</h1>
        </div>

        {error && (
          <div className="bg-red-50 text-red-600 p-4 rounded-lg mb-6 flex items-center gap-3">
            <AlertCircle size={20} />
            <span className="text-sm">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-2 text-cidh-gray-text">Email de connexion</label>
            <div className="relative">
              <Mail className="absolute left-3 top-3.5 text-gray-400" size={18} />
              <input 
                type="email" 
                required 
                className="w-full pl-10 p-3 border rounded-lg focus:ring-2 focus:ring-cidh-blue outline-none transition-all"
                placeholder="admin@cidhconsulting.org"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold mb-2 text-cidh-gray-text">Mot de passe</label>
            <div className="relative">
              <Lock className="absolute left-3 top-3.5 text-gray-400" size={18} />
              <input 
                type="password" 
                required 
                className="w-full pl-10 p-3 border rounded-lg focus:ring-2 focus:ring-cidh-blue outline-none transition-all"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button 
            type="submit" 
            disabled={isLoading}
            className={`w-full bg-cidh-blue text-white py-3 rounded-lg font-bold transition-all flex items-center justify-center gap-3 shadow-lg hover:shadow-cidh-blue/20 transform hover:-translate-y-0.5 active:translate-y-0 ${isLoading ? 'opacity-80 cursor-not-allowed' : 'hover:bg-opacity-95'}`}
          >
            {isLoading ? (
              <>
                <Loader2 className="animate-spin" size={20} />
                <span>Connexion en cours...</span>
              </>
            ) : (
              'Se connecter'
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
            <button onClick={() => navigate('/')} className="text-sm text-gray-400 hover:text-cidh-blue transition-colors">
                Retour au site public
            </button>
        </div>
      </motion.div>
    </div>
  )
}

export default Login
